import React from 'react'
import ReactDOM from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import App from './App'
import './index.css'
import './assets/css/all.min.css'
import './assets/css/remixicon.css'
import 'react-toastify/dist/ReactToastify.css'
import './assets/css/toast.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  // <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  // </React.StrictMode>,
)
